<script setup>
   import { reactive, ref, watchEffect, computed, inject } from 'vue'
   import { useRouter, useRoute } from 'vue-router'

   const router = useRouter()
   const route = useRoute()

   const $storeAuth = inject('$storeAuth')
   const $storeViewLoading = inject('$storeViewLoading')

   const form = reactive({
      email: '',
      password: ''
   })

   const login = () => {
      $storeViewLoading.updateLoading(true)
      $storeAuth.login(form)

      setTimeout(() => $storeViewLoading.updateLoading(false), 3000)
   }

   const checkedAuthentication = ref(false)
   watchEffect(() => checkedAuthentication.value = $storeAuth.checkedAuthentication)

   watchEffect(() => {
		// Check if isAuth is true
		if ( $storeAuth.isAuthenticated ) {
			// Check if the route has a redirect
			if(route.query.redirect) {
				// Once authed, push to the page they were trying to access
				router.push(route.query.redirect)
			} else {
				// Once authed, if there's no redirect, push to the explore
				router.push({ name: 'home' })
			}
		}
   })

   const loginError = ref(null)
   watchEffect(() => loginError.value = $storeAuth.loginError)

   const verificationResent = ref(false)
   watchEffect(() => verificationResent.value = $storeAuth.verificationResent)

   const resendVerification = ref(false)
   const resendEmail = ref('')
   const sendVerification = () => $storeAuth.resendVerification(resendEmail)

   const emailNotVerified = computed(() => loginError.value && loginError.value != 'email_not_verified')
</script>

<template>
   <main class="form-signin">
      <form @submit.prevent="login()" class="cg-column-content">
         <div class="form-floating">
            <input v-model="form.email" type="email" class="form-control" id="floatingInput" :class="{ 'is-invalid': emailNotVerified }">
            <label for="floatingInput">Email</label>
         </div>

         <div class="form-floating">
            <input v-model="form.password" type="password" class="form-control" id="floatingPassword" placeholder="Password" :class="{ 'is-invalid': emailNotVerified }">
            <label for="floatingPassword">Password</label>
         </div>

         <div class="cg-column-content justify-content-lg-between flex-lg-row">
            <div>
               <button class="btn btn-lg btn-primary" type="submit">Sign in</button>
            </div>
            <div class="d-flex gap-2">
               Don't have an account yet? <RouterLink :to="{ name: 'register' }">Lets go.</RouterLink>
            </div>
         </div>

         <div>
            <RouterLink :to="{ name: 'reset.password' }">Forgot your password?</RouterLink>
         </div>
      </form>
      <div v-if="loginError == 'email_not_verified'" class="alert alert-dark d-flex align-items-center justify-content-center flex-column mt-4 gap-2">
         <template v-if="verificationResent">
            <h4 class="m-0">Verification Email Resent.</h4>
            <div>Please check your email for the verification link.</div>
         </template>
         <template v-else>
            <h4 class="m-0">Your email hasn't been verified yet.</h4>
            <template v-if="! resendVerification">
               <div>Please check your email for the verification link.</div>
               <button @click="resendVerification = true" type="button" class="btn btn-sm btn-primary mt-1">Resend Link</button>
            </template>

            <form v-if="resendVerification" @submit.prevent="sendVerification()" class="cg-column-content gap-1">
               <small>Enter your email address.</small>
               <div class="input-group">
                  <input v-model="resendEmail"  type="text" class="form-control" placeholder="Email">
                  <button class="btn btn-outline-primary" type="submit" id="button-addon2">Resend Link</button>
               </div>
            </form>
         </template>
      </div>
      <div v-if="emailNotVerified" class="alert alert-dark border border-danger d-flex align-items-center justify-content-center flex-column mt-4 gap-2">
         <div>{{ loginError }}</div>
      </div>
   </main>
</template>